import {UIController} from "../UIController";
import {SVGComponent} from "@webfruits/toolbox/dist/components/svg/SVGComponent";
import {CoreAssets} from "../../core/CoreAssets";
import {UIComponent} from "@webfruits/core";
import {Tracking} from "../../tracking/Tracking";

/******************************************************************
 * ContactFormController
 *
 * @author matthias.schulz@jash.de
 *****************************************************************/

export class ContactFormController extends UIController {

    /******************************************************************
     * Properties
     *****************************************************************/

    private readonly _submitButton: HTMLButtonElement
    private readonly _form: HTMLFormElement
    private readonly _actionURL: string
    private readonly _gtagFormName: string
    private readonly _successMessage: string

    /******************************************************************
     * Constructor
     *****************************************************************/

    constructor(rootElement: HTMLElement) {
        super(rootElement);
        this._submitButton = this.getElementByClass("kkt-contactform-submit-button") as HTMLButtonElement;
        this._form = this.getElementByClass("kkt-contactform-form") as HTMLFormElement;
        this._actionURL = this._form.dataset.actionUrl;
        this._gtagFormName = this._form.dataset.gtagFormName;
        this._successMessage = this._form.dataset.successMessage;
        this.initListeners()
    }

    /******************************************************************
     * Private Methodes
     *****************************************************************/

    private initListeners(): void {
        this._submitButton.addEventListener("click", e => {
            if (!this._form.checkValidity()) return
            e.preventDefault()
            this.sendData()
        });
    }

    private async sendData() {
        this.enableForm = false;
        const formData = new FormData(this._form);
        const response = await fetch(this._actionURL, {
            method: 'POST',
            body: formData
        })
        const result = await response.json();
        if (response.status == 200 && result.success) {
            if (this._gtagFormName) {
                Tracking.pushLayer({
                    event: 'generate_lead',
                    form_name: this._gtagFormName
                })
            }
            this._form.reset();
            this.showDialog({message: this._successMessage})
        } else {
            const errorMessage = Object.keys(result.errors).map(key => result.errors[key]).join("<br>");
            console.warn(result.message)
            this.showDialog({message: errorMessage})
        }
    }

    private set enableForm(value: boolean) {
        this._submitButton.disabled = !value;
        this._form.style.pointerEvents = value ? "auto" : "none";
        this._form.style.opacity = value ? "1" : "0.2";
        this._form.style.transition = "opacity 0.3s ease";
    }

    private showDialog(args: { message: string }) {
        const dialog = new UIComponent<HTMLDialogElement>("dialog")
        this.enableForm = false;
        dialog.view.className = "kkt-contactform-modal";
        const closeButton = new SVGComponent(CoreAssets.CLOSE_BUTTON);
        closeButton.view.className = "kkt-contactform-modal-close-button";
        closeButton.addNativeListener("click", () => {
            dialog.destroy();
            this.enableForm = true;
        })
        dialog.addChild(closeButton);
        dialog.view.show()
        const message = new UIComponent();
        message.view.innerHTML = args.message;
        message.view.className = "kkt-contactform-modal-success-message";
        dialog.addChild(message);
        this.addChild(dialog);
    }

}
